{
    "dually-listed-stock-quick-search-fields": [
        {
            "label": "Foreign Symbol", "columnname": "foreignSymbol", "placeholder": "Foreign Symbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "NmsSymbol", "columnname": "nmsSymbol", "placeholder": "NmsSymbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Description", "columnname": "description", "placeholder": "Description",
            "width": "", "datatype": "String", "isLarge": true
        }
    ],
    "dually-listed-stock-grid-columns": [
        {
            "display": "true",
            "ui_columnname": "Foreign Exchange",
            "db_columnname": "foreignExchange",
            "datatype": "String",
            "mappingkey": "foreignExchange",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Foreign Symbol",
            "db_columnname": "foreignSymbol",
            "datatype": "String",
            "mappingkey": "foreignSymbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NMS Symbol",
            "db_columnname": "nmsSymbol",
            "datatype": "String",
            "mappingkey": "nmsSymbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Description",
            "db_columnname": "description",
            "datatype": "String",
            "mappingkey": "description",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Sector",
            "db_columnname": "sector",
            "datatype": "String",
            "mappingkey": "sector",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Update Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Last Updated By",
            "db_columnname": "lastUpdatedBy",
            "datatype": "String",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ]
}